<template>
  <section id="whychina">
    <v-container inner>
      <div class="intro-whychina mt-5">
        <h2 class="headline font-secondary mb-4">Why is China doing this?</h2>

        <p class="body-2">
          For power, of course. But beyond power are reasons that are just as important.
        </p>

        <p class="body-2">
          One of the often cited reasons is overcapacity. China has experienced an economic boom in the last few decades, largely driven by manufacturing and industrialisation. Now, the country is facing a bottleneck, especially in its construction industry. Opening new markets as an outlet for its excessive savings continues to fuel the construction business, and prevents China’s economy from turning sluggish.
        </p>

        <p class="body-2">
          China has also been economically reliant on its eastern coastal states for too long. Developing its western region and opening its frontier with Central Asia allows the country’s economy to diversify. At present, the European Union is also the largest trading bloc with China. Establishing more access routes also enhances the country’s economic security.
        </p>

        <p class="body-2">
          A more modest goal  is to internationalise the Renminbi (RMB). China aims to have half of all its foreign trade to be <a href="https://www.business.hsbc.com/rmb-internationalisation" target="_blank">executed in RMB by 2020.</a> In the last few years, the RMB has gained momentum partly due to the BRI, and the rise of China’s cashless society and the virality of WeChat and Alipay.
        </p>
      </div>
    </v-container>

    <figure>
      <img src="@/assets/img/maps/chinaGRP.png" alt="bri-china-grp" class="fluid">
      <figcaption class="caption font-italic text-xs-center">
        China’s Gross Regional Product and Total Population of major cities from 2012-2016. Data taken from: National Bureau of Statistics of China
      </figcaption>
    </figure>
  </section>
</template>

<script>
export default {
  name: 'SectionWhyChina',
};
</script>
